import { useMemo } from "react";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { SelectOption } from "@idw-types/common";
import { FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import { SelectFormGroup } from "../../../../../common/select-form-group/select-form-group";

type ServiceOfferingRefreshRateSelectProps = {
    isDisabled: boolean;
    serviceOffering: FormattedRpServiceConfigurationServiceOffering;
    updateServiceOffering: (serviceOffering: FormattedRpServiceConfigurationServiceOffering) => void;
    refreshRateOptions: Array<SelectOption>;
    defaultRefreshRateOption: SelectOption;
    labelWidth: LabelWidthTypes;
    layout: LayoutTypes;
};

export const ServiceOfferingRefreshRateSelect = (props: ServiceOfferingRefreshRateSelectProps) => {
    const {
        isDisabled,
        serviceOffering,
        updateServiceOffering,
        refreshRateOptions,
        defaultRefreshRateOption,
        labelWidth,
        layout
    } = props;

    const handleReverificationFrequencyChange = (newValue: SelectOption) => {
        updateServiceOffering({ ...serviceOffering, refreshRate: newValue.value });
    };

    const selectedRefreshRateOption = useMemo(() => {
        if (serviceOffering.refreshRate) {
            return refreshRateOptions.find(rro => rro.value === serviceOffering.refreshRate);
        }
        return defaultRefreshRateOption;
    }, [serviceOffering.refreshRate, refreshRateOptions, defaultRefreshRateOption]);

    return (
        <div>
            <SelectFormGroup
                controlId={`federated-idp-service-offering-${serviceOffering.serviceOfferingID}-reverification-select`}
                automationId={`federated-idp-service-offering-${serviceOffering.serviceOfferingID}-reverification-select`}
                ariaLabel={serviceOffering.name}
                label={serviceOffering.name}
                disabled={isDisabled}
                isClearable={false}
                isRequired={true}
                isSearchable={false}
                labelWidth={labelWidth}
                layout={layout}
                onChange={handleReverificationFrequencyChange}
                options={refreshRateOptions}
                selectedOption={selectedRefreshRateOption}
            />
        </div>
    );
};